import { render, staticRenderFns } from "./AffiliatesNavigation.vue?vue&type=template&id=53e165c3&"
import script from "./AffiliatesNavigation.vue?vue&type=script&lang=js&"
export * from "./AffiliatesNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53e165c3')) {
      api.createRecord('53e165c3', component.options)
    } else {
      api.reload('53e165c3', component.options)
    }
    module.hot.accept("./AffiliatesNavigation.vue?vue&type=template&id=53e165c3&", function () {
      api.rerender('53e165c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Affiliates/AffiliatesNavigation.vue"
export default component.exports